import { Box, chakra, Flex } from '@chakra-ui/react';
import { ComponentProps } from 'react';
import reactStringReplace from 'react-string-replace';

import { useAutocompleteContext } from './AutocompleteContext';

type AutocompleteItemProps = {
  text: string;
  icon?: React.ReactNode;
  textProps?: Omit<ComponentProps<typeof chakra.span>, 'children'>;
};

export function AutocompleteItem({
  text,
  icon = false,
  textProps,
}: AutocompleteItemProps) {
  const { focusedValue, keyword, onSelect } = useAutocompleteContext();

  return (
    <Flex
      onClick={(e) => {
        e.stopPropagation();
        onSelect(text);
      }}
      alignItems="center"
      borderRadius="md"
      p={2}
      cursor="pointer"
      bg={focusedValue === text ? 'gray.100' : 'white'}
      _hover={{
        bg: 'gray.100',
      }}
    >
      {icon ? <Box mr={3}>{icon}</Box> : null}
      <chakra.span fontWeight="normal" {...textProps}>
        {reactStringReplace(text, keyword, (match) => (
          <chakra.span fontWeight="semibold" textColor="#0000A3">
            {match}
          </chakra.span>
        ))}
      </chakra.span>
    </Flex>
  );
}

AutocompleteItem.displayName = 'AutocompleteItem';
